import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/fonts/fonts.js';
import '@adornis/popover/x-dropdown.js';
import type { XDropdown, XDropdownContent } from '@adornis/popover/x-dropdown.js';
import type { ILSThemeDefinition } from '@ils/theme/theme.js';
import type { ILSUserOverviewLineExamDayCandidate } from '@legacy-db/ils-user-overview-line.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { repeat } from 'lit/directives/repeat.js';
import type { ILSUser } from '../../db/ils-user.js';

/**
 * @element ils-admin-dropdown-user-osce-trigger
 */
@customElement('ils-admin-dropdown-user-osce-trigger')
export class ILSAdminDropdownUserOsce extends ChemistryLitElement<ILSThemeDefinition> {
  @property({ attribute: false }) user = new RXController<ILSUser>(this, undefined);
  @property({ attribute: false }) examDays = new RXController<Maybe<ILSUserOverviewLineExamDayCandidate[]>>(
    this,
    undefined,
  );

  private readonly dropdownTrigger = createRef<XDropdown>();

  override render() {
    const appointedExamDays = this.examDays.value;
    if (!appointedExamDays) return `...`;
    if (appointedExamDays.length) {
      return html`
        <x-button
          tone="outline"
          icon="expand_more"
          @click=${(e: MouseEvent) => {
            e.stopPropagation();
            this.dropdownTrigger.value?.toggle();
          }}
        >
          ${appointedExamDays.length} Prüfungstage
        </x-button>
        <x-dropdown ${ref(this.dropdownTrigger)}>
          <ils-admin-dropdown-user-osce-content
            .appointedDays=${appointedExamDays}
            slot="dropdown-content"
          ></ils-admin-dropdown-user-osce-content>
        </x-dropdown>
      `;
    } else {
      return html` <x-text> Keine Anmeldungen </x-text> `;
    }
  }
}

/**
 * @element ils-admin-dropdown-user-osce-content
 */
@customElement('ils-admin-dropdown-user-osce-content')
export class ILSAdminDropdownUserOsceContent
  extends ChemistryLitElement<ILSThemeDefinition>
  implements XDropdownContent
{
  @property({ attribute: false }) appointedDays = new RXController<Maybe<ILSUserOverviewLineExamDayCandidate[]>>(
    this,
    undefined,
  );

  // @ts-expect-error trigger?
  private trigger?: XDropdown;
  receiveTrigger(trigger: XDropdown) {
    this.trigger = trigger;
  }

  override render() {
    return html`
      <x-basic-card
        raised
        horizontal
        ${css({
          width: '270px',
          minHeight: '200px',
          maxHeight: '480px',
          overflowY: 'auto',
          background: this.colors.light,
          borderRadius: this.sizes.borderRadius,
        })}
      >
        <x-flex space="md" padding="md">
          <x-h4>Angemeldet zu Prüfungstagen:</x-h4>
          ${repeat(this.appointedDays.value ?? [], examDay => {
            return html`<x-text>${examDay.name}</x-text>`;
          })}
        </x-flex>
      </x-basic-card>
    `;
  }
}
